import {
  PROPERTY_LIST,
  PROPERTY_DETAIL,
  GET_APPLIED_USERS_FOR_PROPERTY,
} from "./actions";

const initialState = {
  property: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  propertyAppliedUsersList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  propertyLoading: true,
  propertyData: {},
};

const propertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROPERTY_LIST:
      return {
        ...state,
        property: payload,
        propertyLoading: false,
      };
    case PROPERTY_DETAIL:
      return {
        ...state,
        propertyData: payload,
        propertyLoading: false,
      };
    case GET_APPLIED_USERS_FOR_PROPERTY:
      return {
        ...state,
        propertyAppliedUsersList: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default propertyReducer;
